<template>
  <div class="draft">
    <div class="pre-title">我的草稿</div>
    <div class="table">
      <div class="table-header">
        <span
          class="header-item"
          :style="{ width: tableWidth[index] ? tableWidth[index] + 'px' : 'auto', flex: tableWidth[index] ? '' : 1}"
          v-for="(item, index) in headerList"
          :key="index"
          >{{ item }}</span
        >
      </div>
      <div class="table-list" v-show="list.length">
        <div class="table-tr" v-for="item,index in list" :key="index">
          <!-- <div class="table-th" :style="{ width: tableWidth[0] + 'px'}">
            <input type="checkbox" class="checkbox" :checked="item.checked" />
          </div> -->
          <div class="table-th" :style="{ width: tableWidth[0] + 'px'}">
            <template v-if="speakerMap[item.dubbing_param.speaker_id]">
              <img class="dubber-image" :src="speakerMap[item.dubbing_param.speaker_id].image" alt="" />
              <div class="dubber-name">{{speakerMap[item.dubbing_param.speaker_id].name}}</div>
            </template>
          </div>
          <div class="table-th click-th" :style="{ flex: 1, textAlign: 'left'}" @click="()=>showDetail(index)">
            <div class="text-desc">
              <div class="title">{{item.dubbing_param.dubbing_name}}</div>
              <div class="info-content">
                <div  class="info" :class="{
                  'hide-info': !openFlag || currentDetailIndex !== index,
                }">
                  {{item.dubbing_param.text}}
                </div>
                <svg-icon name="bottom_arrow" :class="{
                  'rotate-180': openFlag && currentDetailIndex === index,
                  'rotate-0': !openFlag && currentDetailIndex !== index,
                }"></svg-icon>
              </div>
            </div>
          </div>
          <div class="table-th" :style="{ width: tableWidth[2] + 'px'}">
            <div>{{item.dubbing_param.text_len}}</div>
          </div>
          <div class="table-th" :style="{ width: tableWidth[3] + 'px'}">
            <div>{{item.date}}</div>
          </div>
          <div class="table-th" :style="{ width: tableWidth[4] + 'px'}">
            <span @click="()=>opreate(item, 'editor')">
              <SvoiceTooltip title="编辑">
                <svg-icon name="editor" ></svg-icon>
              </SvoiceTooltip>
            </span>
            <span @click="()=>opreate(item, 'delete')">
              <SvoiceTooltip title="删除">
                <svg-icon name="delete" ></svg-icon>
              </SvoiceTooltip>
            </span>
          </div>
        </div>
      </div>
      <NoData tips="暂无草稿" v-show="!list.length"></NoData>
    </div>
    <footer v-show="list.length">
      <!-- <div class="table-operate">
        <input type="checkbox" class="select-content checkbox" :checked="false" />
        <span class="select-content text-all text-center">
          全选
        </span>
        <span class="select-content">
          <button>删除</button>
        </span>
      </div> -->
      <Pagination @jump="getList" :total="total" :resetPage="resetPage"></Pagination>
    </footer>
  </div>
</template>

<script>
import Pagination from 'components/pagination.vue'
import { listDubDraft, deleteDubDraft } from '@/api/dubbing.js'
import { formatUnixTime } from '@/utils/timeformat.js'
import { getSpeakersMap } from 'utils/model.js'
import { scrollTop } from 'utils/utils.js'
import NoData from 'components/no-data.vue'
import SvoiceTooltip from '@/components/svoice-tooltip.vue'

export default {
  name: 'draft',
  props: {
    msg: String
  },
  components: {
    Pagination,
    NoData,
    SvoiceTooltip
  },
  data() {
    return {
      tableWidth: [40, '', 55, 200, 120],
      headerList: [
        "主播",
        "作品内容",
        "字数",
        "订单时间",
        "操作",
      ],
      list: [],
      speakerMap: {},
      total: 0,
      resetPage: false,
      currentDetailIndex: -1,
      openFlag: false
    };
  },
  created() {
    this.getSpeakersMap()
  },
  methods: {
    showDetail (index) {
      if (index !== this.currentDetailIndex) {
        this.openFlag = true
      } else {
        this.openFlag = !this.openFlag
      }
      this.currentDetailIndex = index
    },
    async getSpeakersMap () {
      this.speakerMap = await getSpeakersMap()
    },
    async getList (page) {
      this.$showLoading()
      page.dubbing_type = 1
      const res = await listDubDraft(page)
      if (res.code !== 0) {
        return
      }
      this.resetPage = false
      const {list,total} = res.data
      const newList = list.map((ele) => {
        ele.date = formatUnixTime(new Date(ele.date).getTime() / 1000)
        return ele
      })
      this.list = newList
      this.total = total
      scrollTop(0)
      this.$hideLoading()
    },
    opreate (item, type) {
      console.log(item, type)
      if (type === 'delete') {
        this.deleteDubDraft(item)
      } else if (type === 'editor') {
        this.$store.dispatch('global/setRegenerateFlag', true)
        this.$store.dispatch('global/setDubbingParams', item.dubbing_param)
        this.$store.dispatch('global/setDubbingID', item.id)
        this.$router.push('/maker/create')
      }
    },
    async deleteDubDraft (item) {
      const draft = await deleteDubDraft({
        dubbing_type: 1,
        id: item.id
      })
      console.log(draft)
      this.resetPage = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.draft {
  background-color: #fff;
  border-radius: 4px;
  padding: 40px;
  .pre-title {
    font-size: 18px;
    color: #666666;
  }
  .table {
    width: 100%;
    margin-top: 23px;
    .table-header {
      height: 50px;
      background-color: #f4f5f8;
      font-size: 14px;
      color: #666666;
      line-height: 50px;
      display: flex;
      .header-item {
        display: inline-block;
        text-align: center;
        padding: 0 20px;
      }
    }
    .table-list {
      .table-tr {
        display: flex;
        align-items: center;
        border-bottom: solid 1px #d8d8d8;
        .table-th {
          padding: 15px 20px;
          text-align: center;
          .dubber-image {
            width: 40px;
            height: 40px;
            display: block;
            border-radius: 20px;
          }
          .dubber-name {
            text-align: center;
            margin-top: 5px;
          }
          .pay-button {
            background: #4e6eff;
            border-radius: 4px;
            font-size: 14px;
            color: #ffffff;
            width: 76px;
            height: 26px;
            line-height: 26px;
            margin-top: 3px;
          }
          .svg-icon {
            margin: 0 10px;
            cursor: pointer;
            &:hover {
              filter: invert(85%) sepia(80%) saturate(2500%) hue-rotate(330deg) brightness(115%) contrast(105%);
            }
          }
          .text-desc {
            cursor: pointer;
            .title {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
            .info-content {
              position: relative;
              .svg-icon--bottom_arrow {
                width: 12px;
                height: 12px;
                position: absolute;
                right: -30px;
                top: 4px;
              }
              .hide-info {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
              .info {
                color: #999999;
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
  }
  footer {
    // display: flex;
    // justify-content: space-between;
    margin-top: 18px;
    .table-operate {
      font-size: 14px;
      color: #555555;
      display: flex;
      align-items: center;
      .select-content {
        margin: 0 20px;
        &.text-all {
          width: 40px;
        }
      }
      button {
        font-size: 14px;
        color: #999999;
        border: 1px solid #979797;
        border-radius: 2px;
        background-color: #fff;
        width: 60px;
        height: 24px;
        line-height: 1;
      }
    }
  }
}
</style>
